<template>
    <div class="scroll-lists">
        <div v-if="windowTarget" v-scroll="onScrollY">
            <slot></slot>
        </div>
        <div v-else class="card--info-scroll-target" data-target="contained">
            <div class="card--info-content" data-content="scrollable">
                <slot></slot>
            </div>
        </div>
    </div>
</template>
<style scoped>
.card-lists {
    min-height: 400px;
}
</style>
<script>
export default {
    props: {
        windowTarget: {
            type: Boolean,
            default: true
        }
    },
    data: () => ({}),

    computed: {
        scrollTrigger() {
            return this.$store.getters.getYScrollLoading
        }
    },

    mounted() {
        this.$nextTick(() => {
            if(!this.windowTarget) {
                const scrollTarget = this.$el.querySelector('.card--info-scroll-target')
                scrollTarget.addEventListener('scroll', this.onScrollY, false)
            }
            
        })
    },

    destroyed() {
        if(!this.windowTarget) {
            const scrollTarget = this.$el.querySelector('.card--info-scroll-target')
            scrollTarget.removeEventListener('scroll', this.onScrollY, false)
        }
    },

    methods: {

        onReachScrollBottom(val) {
            if (val) {
                this.$emit('scrolledTillBottom', true)
            } else {
                this.$emit('scrolledTillBottom', false)
            }

        }


    }
}
</script>